<div class="register-page">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <span class="breadcrumb__item">Home</span>
      <span class="breadcrumb__separator" aria-hidden="true">/</span>
      <span class="breadcrumb__item breadcrumb__item--current" aria-current="page"
        >Create Account</span
      >
    </nav>
  </header>

  <mat-card class="register-card" appearance="outlined">
    <mat-card-content>
      <h1 class="register-card__heading">Create Your CapX Account</h1>
      <p class="register-card__subheading">
        Enter your email to get started — it only takes a minute.
      </p>

      @if (errorMessage()) {
        <div class="inline-error" data-testid="error-general" role="alert" aria-live="assertive">
          {{ errorMessage() }}
        </div>
      }

      <form class="register-form" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
        <!-- Duplicate email banner -->
        @if (emailAlreadyRegistered()) {
          <div
            class="duplicate-email-error"
            data-testid="error-duplicate-email"
            role="alert"
            aria-live="assertive"
          >
            That email is already registered.
            <a [routerLink]="['/auth/login']" class="link">Try logging in.</a>
          </div>
        }

        <!-- Email -->
        <div class="field-group">
          <label class="field-label" for="regEmail">Email Address</label>
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              id="regEmail"
              type="email"
              formControlName="email"
              placeholder="you@company.com"
              autocomplete="email"
            />
            <mat-hint>You'll need to verify this address before logging in</mat-hint>
            <mat-error>
              @if (emailControl.hasError('required')) {
                Email address is required
              } @else if (emailControl.hasError('email')) {
                Please enter a valid email address
              } @else if (emailControl.hasError('serverError')) {
                {{ emailControl.getError('serverError') }}
              }
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Terms & Conditions checkbox -->
        <div class="field-group">
          <mat-checkbox formControlName="termsAccepted" data-testid="register-terms">
            I agree to the
            <a href="#" class="link" (click)="openLegal('terms'); $event.preventDefault()"
              >Terms &amp; Conditions</a
            >
            and
            <a href="#" class="link" (click)="openLegal('privacy'); $event.preventDefault()"
              >Privacy Policy</a
            >
          </mat-checkbox>
        </div>

        <!-- AI-assisted assessment consent (POPIA s72) — its own question, asked once -->
        <div class="field-group">
          <app-ai-consent-checkbox
            testId="register-ai-consent"
            [checked]="form.controls.aiConsent.value === true"
            (changed)="onAiConsentChange($event)"
          />
          <!-- Optional here (Constitution §A6.7). An unticked box is a step still
               to come, never a fault (DOC-60 UI-DA-60-03). -->
          @if (form.controls.aiConsent.value !== true) {
            <p class="field-hint" data-testid="register-ai-consent-hint">
              Optional now — if you leave it unticked, we'll ask before any document is checked.
            </p>
          }
        </div>

        <!-- Submit button -->
        <button
          mat-flat-button
          type="submit"
          class="full-width"
          data-testid="register-submit"
          [disabled]="isLoading() || form.invalid"
        >
          @if (isLoading()) {
            <mat-spinner diameter="20" />
          } @else {
            Verify my email
          }
        </button>

        <!-- or divider -->
        <div class="or-divider" aria-hidden="true">
          <span class="or-divider__line"></span>
          <span class="or-divider__text">or</span>
          <span class="or-divider__line"></span>
        </div>

        <!-- Log in link -->
        <button mat-stroked-button type="button" class="full-width" [routerLink]="['/auth/login']">
          Log in to existing account
        </button>

        <p class="register-form__login-prompt">
          Already have an account?
          <a [routerLink]="['/auth/login']" class="link">Log in here</a>
        </p>
      </form>
    </mat-card-content>
  </mat-card>
</div>
